import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Requests = lazy(() => import('./Requests'));

const RequestsConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
		}
	},
	routes: [
		{
			path: '/tl/requests',
			element: <Requests />,
			auth: authModules.tl_default
		}
	]
};

export default RequestsConfig;
